export const whitelistSpecialNeeds = (input) => {
    const services = Array.isArray(input)
      ? input
      : Array.isArray(input?.services)
      ? input.services
      : [];

    if (services.length === 0) return false;

    return services.some((service) => {
      const code = service?.code ?? service;
      const normalized = code ? String(code).toUpperCase() : "";
      return (
        !!normalized &&
        normalized !== "PRIORITY" &&
        normalized !== "PRIO" &&
        normalized !== "ID STAFF"
      );
    });
  };